// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "db72a9962b18608649763c6e3888d01a4e8e3ead/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};